import { actionConstants } from '../actions/actionConstants';

const initState = {
  loading: false,
  isSubmitting: false,
  batchReports: [],
  batchReport: {},
  getBatchReportError: '',
  processes: [],
  process: {},
  getProcessError: '',
  errors: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConstants.START_QUERY:
      return { ...state, errors: '', loading: true };
    case actionConstants.END_QUERY:
      return { ...state, loading: false };
    case actionConstants.START_SUBMISSION:
      return { ...state, isSubmitting: true, errors: '' };
    case actionConstants.END_SUBMISSION:
      return { ...state, isSubmitting: false };
    case actionConstants.GET_BATCH_REPORT_SUCCESS:
      return { ...state, batchReport: action.data, loading: false };
    case actionConstants.GET_BATCH_REPORT_FAILURE:
      return { ...state, getBatchReportError: action.data, loading: false };
    case actionConstants.GET_BATCH_REPORTS_BY_DEPT_SUCCESS:
      return { ...state, batchReports: action.data, loading: false };
    case actionConstants.GET_BATCH_REPORTS_BY_DEPT_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.CREATE_BATCH_REPORT_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.CREATE_BATCH_REPORT_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.EDIT_BATCH_REPORT_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.EDIT_BATCH_REPORT_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.DELETE_BATCH_REPORT_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_BATCH_REPORT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_BATCH_PROCESSES_SUCCESS:
      return { ...state, processes: action.data.items, loading: false };
    case actionConstants.GET_BATCH_PROCESSES_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.GET_BATCH_PROCESS_SUCCESS:
      return { ...state, process: action.data, loading: false };
    case actionConstants.GET_BATCH_PROCESS_FAILURE:
      return { ...state, getProcessError: action.data, loading: false };
    case actionConstants.CREATE_BATCH_PROCESS_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.CREATE_BATCH_PROCESS_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.EDIT_BATCH_PROCESS_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.EDIT_BATCH_PROCESS_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.DELETE_BATCH_PROCESS_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_BATCH_PROCESS_FAILURE:
      return { ...state, errors: action.data };
    default:
      return state;
  }
};
